import { generateMonthOptions } from 'src/utils/era-package'


export const optionsMap = {
  getText: function (value, optionKey) {
    const obj = this[optionKey]?.find(o => o.value === value)
    return obj ? (obj.short || obj.description || obj.value) : value
  },
  stmtMonth: generateMonthOptions(),
  paymentType: [
    { value: '1', description: 'Individual payment (NOT on a statement)' },
    { value: '2', description: '[Daily] Batched by preliminary statement print date and filer code' },
    { value: '3', description: '[Daily] Batched by preliminary statement print date, filer code, and full importer of record number' },
    { value: '5', description: '[Daily] Batched by preliminary statement print date, filer code, and importer of record number without suffix' },
    { value: '6', description: '[Monthly] Batched by preliminary statement print date and filer code' },
    { value: '7', description: '[Monthly] Batched by preliminary statement print date, filer code, and full importer of record number' },
    { value: '8', description: '[Monthly] Batched by preliminary statement print date, filer code, and importer of record number without suffix' },
  ],
  status: [
    { description: 'Accepted', value: 'A' },
    { description: 'Rejected', value: 'R' },
  ],
  statementType: [
    { description: 'Periodic Daily Statement', short: 'PDS', value: "01" },
    { description: 'Daily Statement', short: 'DS', value: "02" },
  ],
  statementStatus: [
    { value: 'Unpaid', },
    { value: 'Paid-D-Auth', },
    { value: 'Paid-PD-Auth', },
    { value: 'Paid-PD-Final', },
    { value: 'Paid-PM-REPL', },
    { value: 'Paid', },
  ],
  authorizationStatus: [
    { value: 'Sent', },
    { value: 'Accepted', },
    { value: 'Rejected', },
    { value: 'Cancelled', },
  ],

}